import {
  JsonFormsDispatch,
  useJsonForms,
  withJsonFormsControlProps,
} from "@jsonforms/react";
import { Button } from "pepsico-ds";
import { useState } from "react";
import { validateSchemawithData } from "../../../utils/commons";
import "./multiStepController.scss";

const MultiStepControllerComponent = (props) => {
  const { schema, uischema, data, visible, config } = props;
  const ctx = useJsonForms();
  const renderers = ctx?.renderers;
  const cells = ctx?.cells;

  // Access parent modal actions from config
  const onCancel = config?.onCancel || (() => {});
  const onSave = config?.onSave || (() => {});

  const steps = uischema?.options?.steps || [];
  const [currentStep, setCurrentStep] = useState(0);

  const extractFieldPaths = (element) => {
    const paths = [];

    if (element.scope) {
      const fieldPath = element.scope.replace("#/properties/", "");
      paths.push(fieldPath);
    }

    if (element.elements) {
      element.elements.forEach((child) => {
        paths.push(...extractFieldPaths(child));
      });
    }

    return paths;
  };

  const getCurrentStepSchema = () => {
    if (!steps[currentStep] || !schema) return null;

    const stepSchema = steps[currentStep].schema;
    if (!stepSchema || !stepSchema.elements) return null;

    const stepFieldPaths = [];
    stepSchema.elements.forEach((element) => {
      stepFieldPaths.push(...extractFieldPaths(element));
    });

    const partialSchema = {
      type: "object",
      properties: {},
      required: [],
    };

    stepFieldPaths.forEach((field) => {
      if (schema.properties[field]) {
        partialSchema.properties[field] = schema.properties[field];
      }
    });

    if (schema.required) {
      partialSchema.required = schema.required.filter((field) =>
        stepFieldPaths.includes(field)
      );
    }

    return partialSchema;
  };

  const isCurrentStepValid = () => {
    const partialSchema = getCurrentStepSchema();
    if (!partialSchema) return true;

    const stepRelevantData = {};
    Object.keys(partialSchema.properties).forEach((key) => {
      stepRelevantData[key] = data[key];
    });

    return validateSchemawithData(partialSchema, stepRelevantData);
  };

  const handlePrevious = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    if (isCurrentStepValid()) {
      setCurrentStep((prev) => Math.min(prev + 1, steps.length - 1));
    }
  };

  if (!visible) {
    return null;
  }

  const currentStepConfig = steps[currentStep];

  return (
    <div className="multi-step-controller">
      <div className="step-content">
        {currentStepConfig && (
          <>
            <div className="step-title">
              <h3>{currentStepConfig.title}</h3>
              {currentStepConfig.description && (
                <p className="step-description">{currentStepConfig.description}</p>
              )}
            </div>

            <div className="step-form">
              <JsonFormsDispatch
                schema={schema}
                uischema={currentStepConfig.schema}
                path=""
                renderers={renderers}
                cells={cells}
                data={data}
              />
            </div>
          </>
        )}
      </div>

      <div className="step-navigation">
        <div className="nav-buttons">
          <div className="nav-left">
            <Button
              text="Cancel"
              variant="secondary"
              size="medium"
              onClick={onCancel}
            />
          </div>
          <div className="nav-right">
            {currentStep > 0 && (
              <Button
                text="Previous"
                variant="secondary"
                size="medium"
                onClick={handlePrevious}
              />
            )}

            {currentStep < steps.length - 1 ? (
              <Button
                text="Next"
                variant="primary"
                size="medium"
                disabled={!isCurrentStepValid()}
                onClick={handleNext}
              />
            ) : (
              <Button
                text="Save"
                variant="primary"
                size="medium"
                disabled={!isCurrentStepValid()}
                onClick={onSave}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const MultiStepController = withJsonFormsControlProps(
  MultiStepControllerComponent
);
